var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "nav",
    {
      staticClass: "navbar navbar-default text-center",
      class: {
        "dark-mode": _vm.useDarkMode,
        "floating-nav": _vm.float,
        "navbar-fixed-top": !_vm.float,
      },
      attrs: { id: "main-nav" },
      on: { click: _vm.navEvent },
    },
    [
      _vm.float ? _c("div", { staticClass: "floating-nav-trigger" }) : _vm._e(),
      _vm.announcementModalOpen
        ? _c("announcement-modal", {
            attrs: { announcement: _vm.announcementDisplay },
            on: { close: _vm.closeAnnouncementModal },
          })
        : _vm._e(),
      _c("div", { staticClass: "container-fluid nav-container" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-12 header-container" }, [
            !_vm.float
              ? _c("div", { staticClass: "navbar-header" }, [
                  _c(
                    "button",
                    {
                      staticClass: "navbar-toggle collapsed",
                      attrs: {
                        "data-toggle": "collapse",
                        "data-target": ".navbar-collapse",
                        "aria-expanded": "false",
                      },
                    },
                    [
                      _c("span", { staticClass: "sr-only" }, [
                        _vm._v(_vm._s(_vm.$t("nav.toggle_nav"))),
                      ]),
                      _c("span", { staticClass: "icon-bar" }),
                      _c("span", { staticClass: "icon-bar" }),
                      _c("span", { staticClass: "icon-bar" }),
                    ]
                  ),
                  _c("div", { staticClass: "navbar-brand" }, [
                    _vm.isOzaria
                      ? _c("a", { attrs: { href: _vm.homeLink } }, [_vm._m(0)])
                      : _c("a", { attrs: { href: _vm.homeLink } }, [
                          !_vm.me.showChinaResourceInfo()
                            ? _c("picture", [
                                _c("source", {
                                  staticClass: "logo-img powered-by",
                                  attrs: {
                                    srcset: "/images/pages/base/logo.webp",
                                    type: "image/webp",
                                  },
                                }),
                                _c("img", {
                                  staticClass: "logo-img powered-by",
                                  attrs: {
                                    src: "/images/pages/base/logo.png",
                                    alt: "CodeCombat logo",
                                  },
                                }),
                              ])
                            : _c("img", {
                                staticClass: "logo-img powered-by",
                                attrs: {
                                  src: "/images/pages/base/logo-cn.png",
                                  alt: "CodeCombat logo",
                                },
                              }),
                        ]),
                    _vm.partnerLogo
                      ? _c("a", { attrs: { href: _vm.homeLink } }, [
                          _c("img", {
                            class: _vm.partnerLogo.className,
                            attrs: {
                              src: _vm.partnerLogo.url,
                              alt: _vm.partnerLogo.alt,
                            },
                          }),
                        ])
                      : _vm._e(),
                  ]),
                ])
              : _vm._e(),
            _vm.isChinaOldBrowser && !_vm.float
              ? _c(
                  "div",
                  {
                    staticClass: "navbar-browser-recommendation navbar-header",
                  },
                  [
                    _c("div", { staticClass: "nav-spacer" }, [
                      _c("div", { staticClass: "navbar-nav" }, [
                        _c(
                          "a",
                          {
                            staticClass: "text-p",
                            attrs: {
                              href: "https://www.google.cn/intl/zh-CN/chrome/",
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("nav.browser_recommendation")))]
                        ),
                      ]),
                    ]),
                  ]
                )
              : _vm._e(),
            _c("div", { staticClass: "collapse navbar-collapse" }, [
              _c("div", { staticClass: "nav-spacer" }),
              !_vm.me.hideTopRightNav() && !_vm.hideNav
                ? _c(
                    "ul",
                    { staticClass: "nav navbar-nav" },
                    [
                      _c("li"),
                      _vm.me.showChinaResourceInfo()
                        ? [
                            _c("li", [
                              _c(
                                "a",
                                {
                                  staticClass: "text-p",
                                  attrs: {
                                    href: "https://blog.koudashijie.com",
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("nav.blog")))]
                              ),
                            ]),
                            _c("li", [
                              _c(
                                "a",
                                {
                                  staticClass: "text-p",
                                  attrs: {
                                    "data-event-action":
                                      "Header Request Quote CTA",
                                    href: "/contact-cn",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("new_home.request_quote"))
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        : _vm._e(),
                      _vm._l(_vm.getNavbarData(), function (navItem) {
                        return _c("li", [
                          navItem.children
                            ? _c("ul", { staticClass: "nav navbar-nav" }, [
                                _c(
                                  "li",
                                  { staticClass: "dropdown dropdown-hover" },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "text-p",
                                        attrs: {
                                          href: _vm.isWideScreen
                                            ? navItem.url
                                            : null,
                                          "data-toggle": "dropdown",
                                          role: "button",
                                          "aria-haspopup": "true",
                                          "aria-expanded": "false",
                                        },
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(_vm._s(_vm.$t(navItem.title))),
                                        ]),
                                        _vm.useDarkMode
                                          ? _c("caret", {
                                              staticClass: "dropdown-caret",
                                              attrs: { color: "white" },
                                            })
                                          : _c("caret", {
                                              staticClass: "dropdown-caret",
                                              attrs: { color: "black" },
                                            }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "ul",
                                      {
                                        staticClass: "dropdown-menu",
                                        class:
                                          navItem.children.some(
                                            (child) => child.description
                                          ) && "text-wide",
                                      },
                                      _vm._l(
                                        navItem.children.filter(
                                          (child) => child.hide !== true
                                        ),
                                        function (child) {
                                          return _c("li", [
                                            _c(
                                              "a",
                                              _vm._b(
                                                {
                                                  staticClass: "text-p",
                                                  class: [
                                                    child.class,
                                                    child.url &&
                                                      _vm.checkLocation(
                                                        child.url
                                                      ) &&
                                                      "text-teal",
                                                  ].filter(Boolean),
                                                  attrs: { href: child.url },
                                                },
                                                "a",
                                                child.attrs,
                                                false
                                              ),
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t(child.title))
                                                ),
                                                child.description
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "text-description",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              child.description
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                          ])
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                ),
                              ])
                            : _c(
                                "a",
                                {
                                  staticClass: "text-p",
                                  attrs: { href: navItem.url },
                                },
                                [_vm._v(_vm._s(_vm.$t(navItem.title)))]
                              ),
                        ])
                      }),
                    ],
                    2
                  )
                : _vm._e(),
            ]),
            !_vm.float
              ? _c("div", { staticClass: "navbar-collapse collapse" }, [
                  !_vm.me.isAnonymous()
                    ? _c("ul", { staticClass: "nav navbar-nav loggedin" }, [
                        _vm.me.isTarena()
                          ? _c("li", [
                              _c(
                                "a",
                                {
                                  staticClass: "text-p",
                                  attrs: { id: "logout-button" },
                                },
                                [_vm._v(_vm._s(_vm.$t("login.log_out")))]
                              ),
                            ])
                          : _c(
                              "li",
                              {
                                staticClass: "dropdown",
                                attrs: { id: "user-account-dropdown" },
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass: "dropdown-toggle text-p",
                                    attrs: {
                                      href: "#",
                                      "data-toggle": "dropdown",
                                      role: "button",
                                      "aria-haspopup": "true",
                                      "aria-expanded": "false",
                                    },
                                  },
                                  [
                                    _c("img", {
                                      staticClass:
                                        "img-circle img-circle-small m-r-1",
                                      class: {
                                        "border-navy": _vm.me.isTeacher(),
                                      },
                                      attrs: { src: _vm.me.getPhotoURL() },
                                    }),
                                    _vm.unread
                                      ? _c("span", {
                                          staticClass: "unreadMessage",
                                        })
                                      : _vm._e(),
                                    _c(
                                      "span",
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("nav.my_account"))
                                        ),
                                        _vm.useDarkMode
                                          ? _c("caret", {
                                              staticClass: "dropdown-caret",
                                              attrs: { color: "white" },
                                            })
                                          : _c("caret", {
                                              staticClass: "dropdown-caret",
                                              attrs: { color: "black" },
                                            }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _c("ul", { staticClass: "dropdown-menu" }, [
                                  _c(
                                    "li",
                                    {
                                      staticClass:
                                        "user-dropdown-header text-center hidden-xs hidden-sm",
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: _vm.cocoPath(
                                              `/user/${_vm.me.getSlugOrID()}`
                                            ),
                                          },
                                        },
                                        [
                                          _c("img", {
                                            staticClass: "img-circle",
                                            class: _vm.me.isTeacher()
                                              ? "border-navy"
                                              : "",
                                            attrs: {
                                              src: _vm.me.getPhotoURL(),
                                            },
                                          }),
                                          _c("h5", [
                                            _vm._v(_vm._s(_vm.me.broadName())),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm.isCodeCombat
                                    ? _c("li", [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "account-dropdown-item",
                                            attrs: {
                                              href: _vm.cocoPath(
                                                `/user/${_vm.me.getSlugOrID()}`
                                              ),
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("nav.profile"))
                                            ),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                  _c("li", [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "account-dropdown-item",
                                        attrs: { href: "/account/settings" },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("play.settings")))]
                                    ),
                                  ]),
                                  _vm.isCodeCombat &&
                                  (_vm.me.isAdmin() ||
                                    _vm.me.isParentHome() ||
                                    _vm.me.isRegisteredHomeUser())
                                    ? _c("li", [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "account-dropdown-item",
                                            attrs: {
                                              id: "manage-billing",
                                              href: "/payments/manage-billing",
                                              target: "_blank",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("account.manage_billing")
                                              )
                                            ),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                  true || _vm.unread
                                    ? _c(
                                        "li",
                                        {
                                          staticClass:
                                            "dropdown dropleft dropdown-hover",
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "account-dropdown-item dropdown-toggle",
                                              attrs: {
                                                href: "#",
                                                "data-toggle": "dropdown",
                                                role: "button",
                                                "aria-haspopup": "true",
                                                "aria-expanded": "false",
                                              },
                                              on: {
                                                click: _vm.readAnnouncement,
                                              },
                                            },
                                            [
                                              this.announcements.length &&
                                              _vm.useDarkMode
                                                ? _c("caret", {
                                                    staticClass: "rotate-left",
                                                    attrs: { color: "white" },
                                                  })
                                                : _vm._e(),
                                              this.announcements.length &&
                                              !_vm.useDarkMode
                                                ? _c("caret", {
                                                    staticClass: "rotate-left",
                                                    attrs: { color: "black" },
                                                  })
                                                : _vm._e(),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "announcement.notifications"
                                                    )
                                                  )
                                                ),
                                              ]),
                                              _vm.unread
                                                ? _c(
                                                    "span",
                                                    { staticClass: "unread" },
                                                    [_vm._v(_vm._s(_vm.unread))]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                          this.announcements.length
                                            ? _c("announcement-nav", {
                                                staticClass: "announcement-nav",
                                              })
                                            : _vm._e(),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.me.isAPIClient()
                                    ? _c("li", [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "account-dropdown-item",
                                            attrs: {
                                              href: "/partner-dashboard",
                                              target: "_blank",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("nav.api_dashboard")
                                              )
                                            ),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm.me.isAdmin() ||
                                  _vm.me.isOnlineTeacher() ||
                                  _vm.me.isParentAdmin()
                                    ? _c("li", [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "account-dropdown-item",
                                            attrs: { href: "/admin" },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("account_settings.admin")
                                              )
                                            ),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm.serverSession &&
                                  _vm.serverSession.amActually
                                    ? _c("li", [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "account-dropdown-item",
                                            attrs: {
                                              id: "nav-stop-spying-button",
                                              href: "#",
                                            },
                                          },
                                          [_vm._v("Stop Spying")]
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm.me.isTeacher()
                                    ? _c("li", [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "account-dropdown-item",
                                            attrs: {
                                              id: "nav-student-mode",
                                              href: "#",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("login.test_as_student")
                                              )
                                            ),
                                          ]
                                        ),
                                      ])
                                    : _vm.serverSession &&
                                      _vm.serverSession.switchingUserActualId &&
                                      _vm.me.isTestStudent()
                                    ? _c("li", [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "account-dropdown-item",
                                            attrs: {
                                              id: "nav-stop-switching-button",
                                              href: "#",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("login.stop_switching")
                                              )
                                            ),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                  _c("li", [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "account-dropdown-item",
                                        attrs: {
                                          id: "logout-button",
                                          href: "#",
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("login.log_out")))]
                                    ),
                                  ]),
                                ]),
                              ]
                            ),
                      ])
                    : _vm._e(),
                  _c("div", { staticClass: "right-side-nav" }, [
                    false
                      ? _c(
                          "ul",
                          {
                            staticClass: "nav navbar-nav text-p login-buttons",
                          },
                          [
                            _c(
                              "li",
                              [
                                _c(
                                  "cta-button",
                                  {
                                    staticClass: "login-button",
                                    attrs: {
                                      id: "login-link",
                                      "data-event-action": "Header Login CTA",
                                      size: "small",
                                      type: "no-background",
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("signup.login")))]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "li",
                              [
                                _c(
                                  "cta-button",
                                  {
                                    staticClass: "signup-button",
                                    attrs: {
                                      id: "create-account-link",
                                      "data-event-action": "Header Sign Up CTA",
                                      size: "small",
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("signup.sign_up")))]
                                ),
                              ],
                              1
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._m(1),
                    _vm.me.isTeacher() &&
                    !_vm.me.hideTopRightNav() &&
                    !_vm.me.isCreatedByClient()
                      ? _c("ul", { staticClass: "nav navbar-nav" }, [
                          _c(
                            "li",
                            [
                              _c(
                                "cta-button",
                                {
                                  staticClass: "request-demo-button",
                                  attrs: {
                                    "data-event-action":
                                      "Header Request Demo CTA",
                                    size: "small",
                                    href: "/schools?openContactModal=true",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("new_home.request_quote"))
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ])
              : _vm._e(),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("picture", [
      _c("source", {
        staticClass: "logo-img oz-logo",
        attrs: {
          srcset: "/images/ozaria/home/ozaria_home_logo.webp",
          type: "image/webp",
        },
      }),
      _c("img", {
        staticClass: "logo-img oz-logo",
        attrs: {
          src: "/images/ozaria/home/ozaria_home_logo.png",
          alt: "Ozaria by CodeCombat logo",
          title: "Ozaria",
          "aria-label": "Home",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("ul", { staticClass: "nav navbar-nav" }, [
      _c("li", { staticClass: "dropdown" }, [
        _c(
          "a",
          {
            staticClass: "dropdown-toggle text-p",
            attrs: {
              href: "#",
              "data-toggle": "dropdown",
              role: "button",
              "aria-haspopup": "true",
              "aria-expanded": "false",
            },
          },
          [
            _c("span", { staticClass: "language-dropdown-current" }, [
              _vm._v("Language"),
            ]),
          ]
        ),
        _c("ul", { staticClass: "dropdown-menu language-dropdown" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }